import type { GridPagerSettings } from "@tql/ui-components-react/kendo/grid";

/**
 * Single source of truth for the page-size options used across all grids.
 *
 * Both the grid pager (which sizes it offers the user) and the items-per-page
 * preference hook (which values it will read/persist) derive from these
 * constants. Keeping them here prevents the pager and the preference validation
 * from drifting apart — a mismatch would silently coerce a user's selection to
 * the default.
 */
export const VALID_ITEMS_PER_PAGE = [25, 50, 75, 100] as const;

export const DEFAULT_ITEMS_PER_PAGE = 25;

export const DEFAULT_EXTERNAL_GRID_PAGER_SETTINGS: GridPagerSettings = {
	buttonCount: 4,
	pageSizes: [...VALID_ITEMS_PER_PAGE],
	info: true,
};
